import ReactDDOM from 'react-dom';
import React, { useState, useEffect } from "react";
import '../forget-password/forget-password.css';
import Button from '@mui/material/Button';
import Carousel from '../../reusable-components/carousel/Carousel';
import { useNavigate } from "react-router-dom";
import Footer from "../../reusable-components/footer/footer";

function PasswordUpdate(props) {
    const navigate = useNavigate();
    const [open, setOpen] = React.useState(false);

    useEffect(() => {
      });

    return (
    <>
        <div className="first-verify__loginContainer">
            <div className='first-verify__leftContainer'>
                <div className='first-verify__logo'></div>
                <div className='first-verify__loginSubContainer update-password-margin'>
                   <span className='first-verify__loginHeading'>{props.content.passwordUpdate.updatePassword}</span>
                    <div className='first-verify__logindetails padding-top-0'>
                        <Button variant="contained" className="login-button" onClick={() => navigate("/")} >{props.content.passwordUpdate.continue}</Button>
                        <Button variant="outlined" className="login-button-backtologin" onClick={() => navigate("/")}>{props.content.passwordUpdate.backToLogin}</Button>
                    </div>
                </div>
                <Footer />
            </div>
            <div className='first-verify__rightContainer'>
                <div className='first-verify__rightSubContainer'>
                    <div className='first-verify__carousel-container'>
                        <Carousel />
                    </div>
                </div>
            </div>
        </div>
    </>
    )
}

export default PasswordUpdate;

